/* import __COLOCATED_TEMPLATE__ from './icon-alert-triangle.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--alert-triangle'],
  width: 18,
  height: 18,
  viewBox: '0 0 16 16'
});